import React from "react";

import { Card, CardActionArea, CardContent, Grid, Tooltip, Typography } from "@mui/material";

const cardStyles = {
  "&:hover": {
    "& svg": {
      color: "primary.main",
    },
    borderColor: "grey.300",
  },
  bgcolor: "grey.100",
  borderColor: "grey.200",
  borderStyle: "solid",
  borderWidth: 1,
  height: "100%",
  transition: "border-color 0.3s",
  width: 220,
};

const cardContentStyles = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  height: "100%",
  px: 4,
  py: 4,
};

const iconStyles = {
  color: "grey.600",
  height: 32,
  transition: "color 0.3s",
  width: 32,
};

interface ITemplateCardProperties {
  IconComponent: React.ElementType;
  onClick: () => void;
  title: string;
  tooltip: string;
}

/**
 * A card that displays a template.
 * @param IconComponent - The icon component to display.
 * @param onClick - The function to call when the card is clicked.
 * @param title - The title of the card.
 * @param tooltip - The tooltip to display when the card is hovered.
 */

export default function TemplateCard({ IconComponent, onClick, title, tooltip }: ITemplateCardProperties) {
  return (
    <Grid item>
      <Tooltip placement="top" title={tooltip}>
        <Card sx={cardStyles}>
          <CardActionArea onClick={onClick}>
            <CardContent sx={cardContentStyles}>
              <IconComponent sx={iconStyles} />
              <Typography component="div" textAlign="center" variant="h6">
                {title}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Tooltip>
    </Grid>
  );
}
